module.exports = "/shifts/components/leaveTypePickerComponent-0a10e3.html";